export const linesToConnect = [
  ["pelvis", "hip_right"],
  ["hip_right", "knee_right"],
  ["knee_right", "ankle_right"],
  ["pelvis", "hip_left"],
  ["hip_left", "knee_left"],
  ["knee_left", "ankle_left"],
  ["shoulder_right", "elbow_right"],
  ["elbow_right", "wrist_right"],
  // ["wrist_right", "hand_right"],
  ["shoulder_left", "elbow_left"],
  ["elbow_left", "wrist_left"],
  // ["wrist_left", "hand_left"],
  ["shoulder_right", "shoulder_left"],
  ["pelvis", "spine_low"],
  ["spine_low", "spine_high"],
  ["spine_high", "shoulder_right"],
  ["spine_high", "shoulder_left"],
  // ["ankle_right", "midfoot_right"],
  // ["ankle_left", "midfoot_left"],
  // ["foot_right", "midfoot_right"],
  // ["foot_left", "midfoot_left"],
];
export const jointsToExclude = [
  "nose",
  "neck",
  "skull_base",
  "skull_top",
  "ear_right",
  "ear_left",
  "clavicle_left",
  "clavicle_right",
  "hand_right",
  "hand_left",
  "neck",
  "foot_right",
  "foot_left",
  "midfoot_right",
  "midfoot_left",
];

export const ballColorsForCircle = [
  {
    color: "white",
    lineWidth: 9,
  },
  {
    color: "#7bb728",
    lineWidth: 5,
  },
  {
    color: "black",
    lineWidth: 6,
    filled: true,
  },
];

export const colorsArr = [
  {
    color: "red",
    lineWidth: 13,
  },
  {
    color: "#7bb728",
    lineWidth: 9,
  },
  {
    color: "yellow",
    lineWidth: 7,
    filled: true,
  },
];
